import React, { useRef } from 'react';
import { Base as DataTable } from '@reusejs/react-tables';
import { DataLoadOrchestrator } from '@reusejs/react-utils';
import SectionLoader from '../../../components/reusables/SectionLoader';
import EmptyState from '../../../components/reusables/EmptyState';
import { getMentorMentee } from '@nx-monorepo/services';
import formatDate from '../../../utils/formatDate';

const Data = ({ response, callAction }) => {
  const tableRef = useRef(null);

  const getMentees = () => {
    return response.data;
  };

  const config = {
    tableWrapperClasses: 'overflow-hidden mx-5 border rounded-lg',
    tableClasses: 'min-w-full divide-y divide-white px-5',
    headerClasses: 'relative py-4 px-5',
    rowEvenClasses: 'bg-gray-100',
    filterable: false,
    columns: [
      {
        label: 'Event Topic',
        identifier: 'topic',

        resolver: (d) => {
          return (
            <div
              className="text-column-blue cursor-pointer"
              onClick={() => callAction(d, 'view')}
            >
              {d?.topic ? d?.topic : '-'}
            </div>
          );
        },
        sortable: false,
      },
      {
        label: 'Date Requested',
        identifier: 'date',
        resolver: (d) => {
          return <div>{d?.data?.mentee_date ? d?.data?.mentee_date : '-'}</div>;
        },
        sortable: false,
      },
      {
        label: 'Created By',
        identifier: 'username',
        resolver: (d) => {
          return <div>{d?.data?.name ? d?.data?.name : '-'}</div>;
        },
        sortable: false,
      },
      {
        label: 'Created On',
        identifier: 'createdAt',
        resolver: (d) => {
          return <div>{formatDate(new Date(d.createdAt), 'dmy')}</div>;
        },
        sortable: false,
      },
      {
        label: 'Mentor Type',
        identifier: 'type',
        resolver: (d) => {
          return (
            <div>
              {d?.data?.type_of_mentoring ? d?.data?.type_of_mentoring : '-'}
            </div>
          );
        },
        sortable: false,
      },
      {
        label: 'Mentor Name',
        identifier: 'mentorname',
        resolver: (d) => {
          return <div>{d?.mentor_name ? d?.mentor_name : 'N/A'}</div>;
        },
        sortable: false,
      },
    ],
  };

  return (
    <div className="mt-10">
      <DataTable
        ref={tableRef}
        config={config}
        defaultSortColumn={0}
        perPage={5}
        dataSource={async (params) => {
          try {
            let response = await getMentees();
            return {
              data: response,
              pagination: {
                total: 0,
              },
            };
          } catch (error) {
            console.log(error);
          }
        }}
      />
    </div>
  );
};

const ErrorState = ({ response }) => {
  return (
    <div className="flex h-96 items-center justify-center">
      {response.data ? response.data : 'Something went wrong!'}
    </div>
  );
};

export default function ({ mode, callAction }) {
  const orchestratorRef = useRef(null);

  const handler = async () => {
    try {
      let result = await getMentorMentee('mentee');
      if (Object.keys(result).length === 0) {
        return {
          state: 'empty',
          data: result,
        };
      }
      return {
        state: 'data',
        data: result,
      };
    } catch (error) {
      return {
        state: 'error',
        data: 'Something went wrong',
      };
    }
  };

  const emptyConfigHeaderCols = [
    {
      label: 'Event Topic',
      identifier: 'event_topic',
      resolver: (d) => {},
      sortable: false,
    },
    {
      label: 'Date Requested',
      identifier: 'date_requested',
      resolver: (d) => {},
      sortable: false,
    },
    {
      label: 'Created By',
      identifier: 'username',
      resolver: (d) => {},
      sortable: false,
    },
    {
      label: 'Created On',
      identifier: 'created_on',
      resolver: (d) => {},
      sortable: false,
    },
    {
      label: 'Mentor Type',
      identifier: 'mentor_type',
      resolver: (d) => {},
      sortable: false,
    },
    {
      label: 'Mentor Name',
      identifier: 'mentor_name',
      resolver: (d) => {},
      sortable: false,
    },
  ];

  return (
    <DataLoadOrchestrator
      handler={handler}
      ref={orchestratorRef}
      components={{
        data: React.forwardRef((props, ref) => (
          <span ref={ref}>
            <Data mode={mode} callAction={callAction} {...props} />
          </span>
        )),
        loading: SectionLoader,
        empty: React.forwardRef((props, ref) => (
          <span ref={ref}>
            <EmptyState tableHeadColumns={emptyConfigHeaderCols} {...props} />
          </span>
        )),
        error: ErrorState,
      }}
    />
  );
}
